import type { MedioPagoPos } from './tipos'

/**
 * Si al total le corresponde el redondeo de efectivo.
 *
 * El redondeo solo aplica cuando TODO se paga con medios que dan vuelto:
 * redondear una transferencia dejaría la conciliación bancaria con una
 * diferencia por cada venta.
 *
 * La regla vive acá, fuera del diálogo, porque tiene que ser EXACTAMENTE la
 * misma que la del servidor y porque el caso que la rompía no se puede probar
 * a mano: con paso de $100 y un total de $1.487, el cajero carga $1.000 en
 * efectivo —la pantalla redondeaba a $1.500 y pedía $500—, elige tarjeta para
 * el resto, y el servidor, que ve los dos medios, calcula $1.487 y rechaza el
 * cobro. Con el cliente adelante.
 *
 * El faltante que entra es el de SIN redondeo, y es a propósito: el faltante
 * con redondeo depende de esta misma decisión, así que usarlo sería circular.
 * Si lo cargado ya cubre el total sin redondear, la lista de pagos está
 * completa y el medio seleccionado no va a entrar; si falta plata, el medio
 * seleccionado es parte de la decisión.
 */
export function aplicaRedondeoEfectivo(
  pagos: { medio: MedioPagoPos }[],
  medioSeleccionado: MedioPagoPos | null,
  faltaSinRedondeoCentavos: number,
): boolean {
  const candidatos =
    faltaSinRedondeoCentavos === 0
      ? pagos.map((p) => p.medio)
      : [...pagos.map((p) => p.medio), ...(medioSeleccionado ? [medioSeleccionado] : [])]

  return candidatos.length > 0 && candidatos.every((m) => m.daVuelto)
}
